import { Injectable } from '@angular/core';
import { UserLoginInput, UserLoginUseCaseService } from 'src/app/core/user/use-case/user-login-use-case.service';
import { UserLogOutUseCaseService } from 'src/app/core/user/use-case/user-log-out-use-case.service';
import { UserRefreshTokenService } from 'src/app/core/user/use-case/user-refresh-token.service';
//import { initOpenReplay } from 'src/app/infra/open-replay';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private userLoginUseCaseService: UserLoginUseCaseService,
    private userLogOutUseCaseService: UserLogOutUseCaseService,
    private userRefreshTokenService: UserRefreshTokenService
  ) { }


  async login(input: UserLoginInput) {
    const result = await this.userLoginUseCaseService.execute(input)

    if(result.isOk()) {
      //initOpenReplay();
    }

    return result
  }

  async logout() {
    return await this.userLogOutUseCaseService.execute()
  }

  refreshToken() {
    return this.userRefreshTokenService.execute()
  }
}
